<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nW9AJM/tc-custom/9781453269244.jpg?1733108845453" alt="This image is the cover for the book Woman Who Knew Too Much"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Woman Who Knew Too Much
      </h1>
      <p class="bookDescription body article font2">
        <b>A mysterious note leads a struggling actress to a strange murder investigation</b><br/>After two decades of striving, Celia is tired of waiting for her big acting break, and finds consolation only in a specific narcotic: mystery novels. After an afternoon binge at the sprawling Strand bookstore, she emerges with a baker’s dozen of second-hand thrillers. Inside one of the novels she finds a real-life mystery that will prove to be the greatest she’s ever read. She discovers a slip of paper listing nine bullet points, starting “in re the murder of the Director.” Who is the Director, why would someone want him dead, and what on earth does Dan Rather have to do with it? As Celia dives into the puzzle, she finds herself locked in a life-or-death struggle with a gang of international conspirators. These evil men would scare her to death if she weren’t a veteran of New York’s toughest battlefield: the audition room.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Thomas Gifford
      </h2>
      
      <p class="authorDescription body article">Thomas Gifford (1937&ndash;2000) was a bestselling author of thriller  novels. Born in Dubuque, Iowa, he moved to Minnesota after graduating  from Harvard. After eight years as a traveling textbook salesman, he  wrote <i>Benchwarmer Bob</i> (1974), a biography of Minnesota Vikings defensive end Bob Lurtsema. <i>The Wind Chill Factor</i> (1975), a novel about dark dealings among ex-Nazis, introduced John Cooper, a character Gifford would revisit in <i>The First Sacrifice</i> (1994). <i>The Wind Chill Factor</i> was one of several books Gifford set in and around Minneapolis.&#160;Gifford won an Edgar Award nomination for <i>The Cavanaugh Quest</i> (1976). <i>The Glendower Legacy</i> (1978), a story about an academic who discovers that George Washington may have been a British spy, was adapted for the film <i>Dirty Tricks</i> (1981), starring Elliott Gould. In the 1980s Gifford wrote suspense  novels under the pen names Thomas Maxwell and Dana Clarins. In 1996 he  moved back to Dubuque to renovate his childhood home. He died of cancer  in 2000. <BR><BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2e5caa1a